import React, { useState, useEffect } from 'react';
import './Pharmaces.css';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import { useAuth } from '../../context/AuthContext';
import ImageShow from '../../Uitiles/ImageShow';
import Paginationnew from '../../Uitiles/Paginationnew';
import { Button, Modal, Progress, message, Select, DatePicker, Input, Space } from 'antd';
import { Form, InputGroup, Badge } from 'react-bootstrap';
import { PlusOutlined, EditOutlined, DeleteOutlined, CloudUploadOutlined, DownloadOutlined, UploadOutlined, LoginOutlined } from '@ant-design/icons';

import { read, utils } from 'xlsx';
import CryptoJS from "crypto-js";

const { TextArea } = Input;

const Pharmaces = () => {
    const { login } = useAuth();
    const [pharmacies, setPharmacies] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingPharmacy, setEditingPharmacy] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [importModalVisible, setImportModalVisible] = useState(false);
    const [selectedCity, setSelectedCity] = useState('');
    const [citySearchTerm, setCitySearchTerm] = useState('');
    const [citySuggestions, setCitySuggestions] = useState([]);
    const [showCitySuggestions, setShowCitySuggestions] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const [cleanedData, setCleanedData] = useState([]);
    const [showDataPreview, setShowDataPreview] = useState(false);
    const [isFetchingData, setIsFetchingData] = useState(false);
    const [processingTime, setProcessingTime] = useState(0);
    const [currentProcessingPharmacy, setCurrentProcessingPharmacy] = useState('');
    const [bannerUrl, setBannerUrl] = useState('');
    const [bannerId, setBannerId] = useState('');
    const [timingsShow, setTimingsShow] = useState(false);
    const [timings, setTimings] = useState([]);
    const [photoUrl, setPhotoUrl] = useState('');
    const [photoId, setPhotoId] = useState('');
    const [modalData, setModalData] = useState({});

    // Import conditions
    const [importConditions, setImportConditions] = useState({
        includeImages: true,
        keepGoogleId: true,
        includeReviews: true,
        includeWebsite: true,
        includeHours: true
    });

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zip_code: '',
        license_number: '',
        owner_name: '',
        status: 'active',
        banner: '',
        photo: '',
        lat: '',
        long: ''
    });

    // Google Maps API key
    const GOOGLE_MAPS_API_KEY = 'AIzaSyCnZieUw1AIEKfuQbwsGlKNjXROQAybwvI';

    useEffect(() => {
        fetchPharmacies();
    }, [currentPage, itemsPerPage, searchTerm]);

    // Load Google Maps API
    useEffect(() => {
        const loadGoogleMapsAPI = () => {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            }
        };
        loadGoogleMapsAPI();
    }, []);

    // City search with Google Places API
    const searchCities = async (query) => {
        if (!query.trim() || !window.google) return;

        try {
            const service = new window.google.maps.places.AutocompleteService();
            const request = {
                input: query,
                types: ['(cities)'],
                componentRestrictions: { country: 'in' } // Restrict to India
            };

            service.getPlacePredictions(request, (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    setCitySuggestions(predictions.map(prediction => ({
                        description: prediction.description,
                        placeId: prediction.place_id
                    })));
                    setShowCitySuggestions(true);
                }
            });
        } catch (error) {
            console.error('Error searching cities:', error);
        }
    };

    const handleCitySearch = (value) => {
        setCitySearchTerm(value);
        if (value.length > 2) {
            searchCities(value);
        } else {
            setCitySuggestions([]);
            setShowCitySuggestions(false);
        }
    };

    const selectCity = async (city) => {
        setSelectedCity(city.description);
        setCitySearchTerm(city.description);
        setShowCitySuggestions(false);

        // Automatically fetch pharmacy data for the selected city
        await fetchPharmaciesFromGoogleMaps(city.description, city.placeId);
    };

    // Fetch pharmacies from Google Places API with enhanced data
    const fetchPharmaciesFromGoogleMaps = async (cityName, placeId) => {
        if (!window.google) {
            message.error('Google Maps API not loaded. Please try again.');
            return;
        }

        setIsFetchingData(true);
        setCleanedData([]);
        setShowDataPreview(false);
        setProcessingTime(0);

        const startTime = Date.now();

        try {
            console.log('Fetching pharmacies for city:', cityName);

            // First, get the city coordinates using Geocoding service
            const geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ address: cityName }, (results, status) => {
                if (status === 'OK' && results[0]) {
                    const cityLocation = results[0].geometry.location;
                    console.log('City coordinates:', cityLocation.lat(), cityLocation.lng());

                    // Now search for pharmacies using NearbySearch with proper location
                    const service = new window.google.maps.places.PlacesService(document.createElement('div'));

                    const request = {
                        location: cityLocation,
                        radius: 100000, // 100km radius - increased for more results
                        type: 'pharmacy',
                        keyword: 'pharmacy'
                    };

                    console.log('Searching pharmacies with request:', request);

                    const allPharmacies = [];

                    // Strategy 1: Nearby Search
                    service.nearbySearch(request, (nearbyResults, nearbyStatus) => {
                        console.log('Nearby search results:', nearbyStatus, nearbyResults?.length || 0);

                        if (nearbyStatus === window.google.maps.places.PlacesServiceStatus.OK && nearbyResults) {
                            allPharmacies.push(...nearbyResults);
                        }

                        // Strategy 2: Text Search with multiple queries
                        const searchQueries = [
                            `pharmacy in ${cityName}`,
                            `medical store in ${cityName}`,
                            `drug store in ${cityName}`,
                            `chemist in ${cityName}`,
                            `${cityName} pharmacy`,
                            `${cityName} medical store`
                        ];

                        let completedSearches = 0;

                        searchQueries.forEach((query, index) => {
                            const textRequest = {
                                query: query,
                                type: 'pharmacy',
                                maxResults: 60
                            };

                            service.textSearch(textRequest, (textResults, textStatus) => {
                                completedSearches++;

                                if (textStatus === window.google.maps.places.PlacesServiceStatus.OK && textResults) {
                                    // Remove duplicates based on place_id
                                    const existingIds = allPharmacies.map(p => p.place_id);
                                    const newPharmacies = textResults.filter(p => !existingIds.includes(p.place_id));
                                    allPharmacies.push(...newPharmacies);
                                }

                                // Process all results when all searches are complete
                                if (completedSearches === searchQueries.length) {

                                    if (allPharmacies.length > 0) {
                                        // Remove duplicates
                                        const uniquePharmacies = allPharmacies.filter((pharmacy, index, self) =>
                                            index === self.findIndex(p => p.place_id === pharmacy.place_id)
                                        );
                                        processPharmacyData(uniquePharmacies, cityName, startTime);
                                    } else {
                                        console.error('No pharmacy data found with any search method');
                                        message.warning(`No pharmacy data found for ${cityName}. Please try a different city.`);
                                    }
                                    setIsFetchingData(false);
                                }
                            });
                        });
                    });

                } else {
                    console.error('Error geocoding city:', status);
                    message.error(`Error finding location for ${cityName}. Please try again.`);
                    setIsFetchingData(false);
                }
            });

        } catch (error) {
            console.error('Error fetching pharmacies from Google Maps:', error);
            message.error('Error fetching pharmacy data from Google Maps. Please try again.');
            setIsFetchingData(false);
        }
    };

    // Process pharmacy data with enhanced information
    const processPharmacyData = async (places, cityName, startTime) => {
        console.log('Processing pharmacy data...');

        const processedPharmacies = [];

        for (let i = 0; i < places.length; i++) {
            const place = places[i];
            setCurrentProcessingPharmacy(place.name);

            // Get detailed place information
            const detailedPlace = await getDetailedPlaceInfo(place.place_id);

            // CRITICAL: Get coordinates from place geometry - 100% required
            let latitude = 0;
            let longitude = 0;

            // Extract actual coordinates from place.geometry.location
            if (place.geometry && place.geometry.location) {
                try {
                    latitude = place.geometry.location.lat();
                    longitude = place.geometry.location.lng();
                } catch (error) {
                    console.error('Error extracting coordinates:', error);
                    latitude = 0;
                    longitude = 0;
                }
            }

            // CRITICAL: Process photos to get image URLs - 100% required
            const photoUrls = [];

            // First try to get photos from the place object itself
            if (place.photos && place.photos.length > 0) {
                place.photos.forEach((photo, index) => {
                    try {
                        const photoUrl = photo.getUrl({ maxWidth: 400, maxHeight: 300 });
                        photoUrls.push(photoUrl);
                    } catch (error) {
                        photoUrls.push('https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&maxheight=300&photo_reference=default');
                    }
                });
            }

            // If no photos from place, try detailed place
            if (photoUrls.length === 0 && detailedPlace?.photos && detailedPlace.photos.length > 0) {
                detailedPlace.photos.forEach((photo, index) => {
                    try {
                        const photoUrl = photo.getUrl({ maxWidth: 400, maxHeight: 300 });
                        photoUrls.push(photoUrl);
                    } catch (error) {
                        photoUrls.push('https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&maxheight=300&photo_reference=default');
                    }
                });
            }

            // If still no photos, add default
            if (photoUrls.length === 0) {
                photoUrls.push('https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&maxheight=300&photo_reference=default');
            }

            const pharmacy = {
                id: i + 1,
                name: place.name,
                email: `${place.name.toLowerCase().replace(/\s+/g, '')}@pharmacy.com`,
                phone: place.formatted_phone_number || detailedPlace?.formatted_phone_number || '+91-XXXXXXXXXX',
                address: place.vicinity || place.formatted_address || detailedPlace?.formatted_address || '',
                city: cityName,
                state: '', // Will be extracted from address
                zip_code: '', // Not available in Google Places
                license_number: `PH${Math.random().toString(36).substr(2, 6).toUpperCase()}`,
                owner_name: 'Owner', // Not available in Google Places
                status: 'active',
                google_place_id: place.place_id,
                rating: place.rating || 0, // Actual rating from Google
                user_ratings_total: place.user_ratings_total || 0, // Actual review count from Google
                website: place.website || detailedPlace?.website || '',
                photos: photoUrls, // Array of actual photo URLs
                opening_hours: detailedPlace?.opening_hours || null,
                reviews: detailedPlace?.reviews || [],
                latitude: latitude, // Actual latitude from Google
                longitude: longitude, // Actual longitude from Google
                imported_at: new Date().toISOString(),
                import_source: 'google_maps',
                processing_time: Date.now() - startTime,
                pass: "Ravindra12@"
            };

            processedPharmacies.push(pharmacy);
            setProcessingTime(Date.now() - startTime);
        }

        const cleaned = cleanDataWithAI(processedPharmacies);
        setCleanedData(cleaned || []);
        setShowDataPreview(true);
        setCurrentProcessingPharmacy('');
    };

    // Get detailed place information
    const getDetailedPlaceInfo = (placeId) => {
        return new Promise((resolve) => {
            const service = new window.google.maps.places.PlacesService(document.createElement('div'));

            const request = {
                placeId: placeId,
                fields: ['formatted_phone_number', 'website', 'photos', 'opening_hours', 'reviews', 'formatted_address', 'geometry']
            };

            service.getDetails(request, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    resolve(place);
                } else {
                    console.log('Could not get detailed info for place:', placeId);
                    resolve(null);
                }
            });
        });
    };

    // AI-powered data cleaning function
    const cleanDataWithAI = (rawData) => {
        try {
            if (!Array.isArray(rawData)) {
                return [];
            }

            const cleanedData = rawData.map((pharmacy, index) => {
                const cleaned = {
                    name: pharmacy.name?.trim() || '',
                    email: pharmacy.email?.toLowerCase().trim() || '',
                    phone: pharmacy.phone?.replace(/[^\d+\-\(\)\s]/g, '') || '',
                    address: pharmacy.address?.trim() || '',
                    city: pharmacy.city?.trim() || selectedCity,
                    state: pharmacy.state?.trim() || '',
                    zip_code: pharmacy.zip_code?.trim() || '',
                    license_number: pharmacy.license_number?.trim() || '',
                    owner_name: pharmacy.owner_name?.trim() || '',
                    status: pharmacy.status?.toLowerCase() === 'active' ? 'active' : 'inactive',
                    google_place_id: pharmacy.google_place_id || '',
                    rating: pharmacy.rating || 0,
                    user_ratings_total: pharmacy.user_ratings_total || 0,
                    website: pharmacy.website || '',
                    imported_at: pharmacy.imported_at || new Date().toISOString(),
                    import_source: pharmacy.import_source || 'google_maps'
                };

                // AI-powered enhancements
                if (cleaned.email && !cleaned.email.includes('@')) {
                    cleaned.email = `${cleaned.name.toLowerCase().replace(/\s+/g, '')}@pharmacy.com`;
                }

                if (cleaned.phone && !cleaned.phone.startsWith('+')) {
                    cleaned.phone = `+91-${cleaned.phone}`;
                }

                if (cleaned.city && selectedCity) {
                    cleaned.city = selectedCity;
                }

                return {
                    ...cleaned,
                    id: index + 1,
                    originalData: pharmacy
                };
            });

            return cleanedData;
        } catch (error) {
            console.error('Error cleaning data with AI:', error);
            return [];
        }
    };

    const fetchPharmacies = async () => {
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'pharmacies';
            const conditions = {};
            const orderBy = "id DESC";
            const search = {
                ...searchTerm ? { name: searchTerm } : {}
            };
            const pagination = {
                page: currentPage,
                limit: itemsPerPage
            };
            const margedata = {};
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("Response:", response);
            if (response.success) {
                setPharmacies(response.data || []);
                // Use totalPages directly from response if available, otherwise calculate
                // Matching Ambulances.js pattern as requested
                if (response.totalPages) {
                    setTotalItems(response.totalPages * itemsPerPage); // Mocking total items for Paginationnew if it relies on it, or just pass totalPages
                } else if (response.total) {
                    setTotalItems(response.total);
                }
            } else {
                console.error('Error fetching pharmacies:', response.message);
                // Fallback to sample data for demo
                setPharmacies(getSamplePharmacies());
                setTotalItems(50);
            }
        } catch (error) {
            console.error('Error fetching pharmacies:', error);
            // Fallback to sample data for demo
            setPharmacies(getSamplePharmacies());
            setTotalItems(50);
        }
        setLoading(false);
    };

    const getSamplePharmacies = () => {
        return [
            {
                id: 1,
                name: 'MedPlus Pharmacy',
                email: 'info@medplus.com',
                phone: '+1-555-0123',
                address: '123 Main Street',
                city: 'New York',
                state: 'NY',
                zip_code: '10001',
                license_number: 'PH123456',
                owner_name: 'John Smith',
                status: 'active'
            },
            {
                id: 2,
                name: 'HealthCare Pharmacy',
                email: 'contact@healthcare.com',
                phone: '+1-555-0124',
                address: '456 Oak Avenue',
                city: 'Los Angeles',
                state: 'CA',
                zip_code: '90210',
                license_number: 'PH789012',
                owner_name: 'Sarah Johnson',
                status: 'active'
            },
            {
                id: 3,
                name: 'Community Drug Store',
                email: 'info@communitydrug.com',
                phone: '+1-555-0125',
                address: '789 Pine Street',
                city: 'Chicago',
                state: 'IL',
                zip_code: '60601',
                license_number: 'PH345678',
                owner_name: 'Mike Davis',
                status: 'inactive'
            }
        ];
    };

    const handleAdd = () => {
        setEditingPharmacy(null);
        setFormData({
            name: '',
            email: '',
            phone: '',
            address: '',
            city: '',
            state: '',
            zip_code: '',
            license_number: '',
            owner_name: '',
            status: 'active',
            banner: '',
            photo: '',
            lat: '',
            long: ''
        });
        setBannerId('');
        setBannerUrl('');
        setPhotoId('');
        setPhotoUrl('');
        setIsModalVisible(true);
    };

    const handleEdit = (pharmacy) => {
        setEditingPharmacy(pharmacy);
        setFormData(pharmacy);
        setBannerUrl(pharmacy.bannerurl || '');
        setBannerId(pharmacy.bannerid || '');
        setPhotoUrl(pharmacy.photourl || '');
        setPhotoId(pharmacy.photoid || '');
        setIsModalVisible(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this pharmacy?')) {
            try {
                const tableSchema = '';
                const tableName = 'pharmacies';
                const conditions = { id: id };
                const response = await oneKlicks.delete(tableSchema, tableName, conditions);
                if (response.success) {
                    setPharmacies(pharmacies.filter(item => item.id !== id));
                    message.success('Pharmacy deleted successfully');
                } else {
                    console.error('Error deleting pharmacy:', response.message);
                    message.error('Error deleting pharmacy');
                }
            } catch (error) {
                console.error('Error deleting pharmacy:', error);
                message.error('Error deleting pharmacy');
            }
        }
    };

    const handleInputChange = async (e) => {
        const { name, value } = e.target;

        if (name === 'banner' || name === 'photo') {
            if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];

                if (!file.type.startsWith('image/')) {
                    message.error('Please upload an image file.');
                    return;
                }

                const reader = new FileReader();
                const root = 'pharmacies';
                const status = 'public';
                const uploadimage = await OneKlicksFileSDK.uploadFile(root, status, file);

                if (uploadimage && (uploadimage.fileid || uploadimage.fileId)) {
                    const fId = uploadimage.fileid || uploadimage.fileId;
                    if (name === 'banner') {
                        setBannerId(fId);
                        setBannerUrl(fId);
                    } else {
                        setPhotoId(fId);
                        setPhotoUrl(fId);
                    }
                } else {
                    console.error('Upload failed:', uploadimage);
                    message.error('File upload failed. Please try again.');
                }
                reader.readAsDataURL(file);
            }
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const tableSchema = '';
            const tableName = 'pharmacies';
            const data = {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                address: formData.address,
                city: formData.city,
                state: formData.state,
                zip_code: formData.zip_code,
                license_number: formData.license_number,
                owner_name: formData.owner_name,
                status: formData.status,
                bannerid: bannerId,
                bannerurl: bannerId,
                photoid: photoId,
                photourl: photoId,
                photoid: photoId,
                photourl: photoId,
                latitude: formData.lat,
                longitude: formData.long,
                user_type: 'pharmacy'
            };

            // Add default password if creating new
            if (!editingPharmacy) {
                data.pass = CryptoJS.SHA256("Ravindra12@").toString();
            }

            if (editingPharmacy) {
                const conditions = { id: editingPharmacy.id };
                const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
                if (response.success) {
                    setPharmacies(pharmacies.map(item =>
                        item.id === editingPharmacy.id ? { ...formData, id: item.id } : item
                    ));
                    message.success('Pharmacy updated successfully');
                } else {
                    console.error('Error updating pharmacy:', response.message);
                    message.error('Error updating pharmacy');
                }
            } else {
                const conditions = {};
                const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
                if (response.success) {
                    const newPharmacy = { ...formData, id: Date.now() };
                    setPharmacies([newPharmacy, ...pharmacies]);
                    setBannerId('');
                    setBannerUrl('');
                    setPhotoId('');
                    setPhotoUrl('');
                    message.success('Pharmacy added successfully');
                } else {
                    console.error('Error adding pharmacy:', response.message);
                    message.error('Error adding pharmacy');
                }
            }
            setIsModalVisible(false);
            fetchPharmacies();
        } catch (error) {
            console.error('Error saving pharmacy:', error);
            message.error('Error saving pharmacy');
        }
    };

    const handleImportSubmit = async (e) => {
        e.preventDefault();

        if (!selectedCity) {
            message.warning('Please select a city to import pharmacies');
            return;
        }

        if (!Array.isArray(cleanedData) || cleanedData.length === 0) {
            message.warning('No pharmacy data available to import. Please select a city first.');
            return;
        }

        setImportProgress(0);
        const totalPharmacies = cleanedData.length;
        let importedCount = 0;
        const importStartTime = Date.now();

        try {
            for (let i = 0; i < cleanedData.length; i++) {
                const pharmacy = cleanedData[i];
                setCurrentProcessingPharmacy(pharmacy.name);

                try {
                    const tableSchema = '';
                    const tableName = 'pharmacies';

                    const conditions = {
                        google_place_id: importConditions.keepGoogleId,
                    };

                    const dataToSave = {
                        name: String(pharmacy.name || 'Unknown Pharmacy'),
                        email: String(pharmacy.email || `${pharmacy.name?.toLowerCase().replace(/\s+/g, '') || 'pharmacy'}@pharmacy.com`),
                        phone: String(pharmacy.phone || '+91-XXXXXXXXXX'),
                        address: String(pharmacy.address || ''),
                        latitude: String(pharmacy.latitude || 0),
                        longitude: String(pharmacy.longitude || 0),
                        photos: JSON.stringify(pharmacy.photos || ['https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&maxheight=300&photo_reference=default']),
                        rating: String(pharmacy.rating || 0),
                        user_ratings_total: String(pharmacy.user_ratings_total || 0),
                        website: String(pharmacy.website || ''),
                        opening_hours: JSON.stringify(pharmacy.opening_hours || null),
                        reviews: JSON.stringify(pharmacy.reviews || []),
                        formatted_address: String(pharmacy.formatted_address || ''),
                        google_place_id: String(pharmacy.google_place_id || ''),
                        city: String(selectedCity || ''),
                        state: String(pharmacy.state || ''),
                        zip_code: String(pharmacy.zip_code || ''),
                        license_number: String(pharmacy.license_number || `PH${Math.random().toString(36).substr(2, 6).toUpperCase()}`),
                        owner_name: String(pharmacy.owner_name || 'Owner'),
                        status: String(pharmacy.status || 'active'),
                        processing_time: String(pharmacy.processing_time || 0),
                        import_timestamp: String(new Date().toISOString()),
                        imported_at: String(new Date().toISOString()),
                        import_source: String('google_maps'),
                        includeImages: String(importConditions.includeImages),
                        includeReviews: String(importConditions.includeReviews),
                        includeWebsite: String(importConditions.includeWebsite),
                        includeWebsite: String(importConditions.includeWebsite),
                        includeHours: String(importConditions.includeHours),
                        pass: CryptoJS.SHA256("Ravindra12@").toString(),
                        user_type: 'pharmacy'
                    };

                    if (importConditions.keepGoogleId && pharmacy.google_place_id) {
                        dataToSave.google_place_id = pharmacy.google_place_id;
                    }
                    if (importConditions.includeWebsite && pharmacy.website) {
                        dataToSave.website = pharmacy.website;
                    }
                    if (importConditions.includeReviews && pharmacy.reviews) {
                        dataToSave.reviews = pharmacy.reviews;
                        dataToSave.rating = pharmacy.rating;
                        dataToSave.user_ratings_total = pharmacy.user_ratings_total;
                    }
                    if (importConditions.includeHours && pharmacy.opening_hours) {
                        dataToSave.opening_hours = pharmacy.opening_hours;
                    }
                    if (importConditions.includeImages && pharmacy.photos && pharmacy.photos.length > 0) {
                        const internalPhotos = [];
                        for (const pUrl of pharmacy.photos) {
                            if (pUrl && pUrl.startsWith('http')) {
                                const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('pharmacies', 'public', pUrl);
                                const fId = uploadRes?.fileid || uploadRes?.fileId;
                                if (fId) {
                                    internalPhotos.push(fId);
                                } else {
                                    internalPhotos.push(pUrl);
                                }
                            } else {
                                internalPhotos.push(pUrl);
                            }
                        }
                        dataToSave.photos = JSON.stringify(internalPhotos);
                        if (internalPhotos.length > 0) {
                            dataToSave.photoid = internalPhotos[0];
                            dataToSave.photourl = internalPhotos[0];
                            dataToSave.bannerid = internalPhotos[1] || internalPhotos[0];
                            dataToSave.bannerurl = internalPhotos[1] || internalPhotos[0];
                        }
                    }
                    dataToSave.processing_time = pharmacy.processing_time || 0;

                    Object.keys(dataToSave).forEach(key => {
                        if (dataToSave[key] === undefined || dataToSave[key] === null) {
                            dataToSave[key] = '';
                        }
                    });

                    // Defaults if needed
                    if (!dataToSave.latitude || dataToSave.latitude === '0' || dataToSave.latitude === '') {
                        dataToSave.latitude = '17.3850';
                    }
                    if (!dataToSave.longitude || dataToSave.longitude === '0' || dataToSave.longitude === '') {
                        dataToSave.longitude = '78.4867';
                    }
                    if (!dataToSave.photos || dataToSave.photos === '[]' || dataToSave.photos === '') {
                        dataToSave.photos = JSON.stringify(['https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&maxheight=300&photo_reference=default']);
                    }

                    const response = await oneKlicks.create(tableSchema, tableName, dataToSave, conditions);
                    if (response.success) {
                        importedCount++;
                    }
                } catch (error) {
                    console.error(`❌ Error importing pharmacy: ${pharmacy.name}`, error);
                }

                setImportProgress(((i + 1) / totalPharmacies) * 100);
                await new Promise(resolve => setTimeout(resolve, 100));
            }

            const totalImportTime = Date.now() - importStartTime;
            message.success(`Successfully imported ${importedCount} pharmacies from ${selectedCity}`);
        } catch (error) {
            console.error('Error during import process:', error);
            message.error(`Error during import: ${error.message}`);
        } finally {
            setImportModalVisible(false);
            setCleanedData([]);
            setShowDataPreview(false);
            setSelectedCity('');
            setCitySearchTerm('');
            setImportProgress(0);
            setCurrentProcessingPharmacy('');
            setProcessingTime(0);
            fetchPharmacies();
        }
    };

    const [importing, setImporting] = useState(false);
    const fileInputRef = React.useRef(null);

    const handleImportClick = () => {
        fileInputRef.current.click();
    };

    const handleExcelFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImporting(true);
        const reader = new FileReader();

        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = utils.sheet_to_json(ws);

                if (data.length === 0) {
                    message.error("Excel file is empty");
                    setImporting(false);
                    return;
                }

                let successCount = 0;
                let failCount = 0;

                message.loading(`Processing ${data.length} records...`, 2);

                for (const row of data) {
                    try {
                        if (!row.Name && !row.name && !row.display_name) continue;

                        const displayName = row.Name || row.name || row.display_name;
                        let email = row.Email || row.email;
                        const phone = row.Phone || row.phone;
                        const address = row.Address || row.address;

                        let photoUrl = row.Image || row.PhotoUrl || row.photourl || row.profile_photo_url || row.profile_photo || row.ImageURL || row['Image URL'] || '';
                        let lat = row.Lat || row.lat || row.Latitude || row.latitude;
                        let lng = row.Lng || row.lng || row.Longitude || row.longitude;

                        // Default License Number if missing
                        let licenseNumber = row.License || row.license_number || row.license;
                        if (!licenseNumber) {
                            licenseNumber = `PH${Math.floor(100000 + Math.random() * 900000)}`;
                        }

                        // Default to Hyderabad if coordinates missing
                        if (!lat || !lng) {
                            lat = '17.3850';
                            lng = '78.4867';
                        }

                        // Logic for PhotoID and PhotoURL
                        let finalPhotoId = '';
                        let finalPhotoUrl = '';

                        // If the input is just a number (ID), use it
                        if (photoUrl && /^\d+$/.test(String(photoUrl))) {
                            finalPhotoId = String(photoUrl);
                            finalPhotoUrl = finalPhotoId;
                        }
                        // If it's a URL
                        else if (photoUrl && typeof photoUrl === 'string' && photoUrl.startsWith('http')) {
                            const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('pharmacies', 'public', photoUrl);
                            const fId = uploadRes?.fileid || uploadRes?.fileId;
                            if (fId) {
                                finalPhotoId = fId;
                                finalPhotoUrl = fId;
                            } else {
                                finalPhotoUrl = photoUrl;
                                // Try to extract ID if it matches our pattern
                                const match = photoUrl.match(/\/file\/(\d+)/) || photoUrl.match(/\/pharmacies\/(\d+)/) || photoUrl.match(/\/uploads\/\d+\/[^/]+\/(\d+)/);
                                if (match) {
                                    finalPhotoId = match[1];
                                    finalPhotoUrl = match[1];
                                }
                            }
                        }
                        // Fallback: if it's some other string, just save it as URL (could be base64 or relative?)
                        else if (photoUrl) {
                            finalPhotoUrl = photoUrl;
                        }


                        const commonData = {
                            name: displayName.trim(),
                            phone: phone ? String(phone).trim() : '',
                            address: address ? address.trim() : '',
                            photourl: finalPhotoUrl,
                            photoid: finalPhotoId,
                            latitude: lat,
                            longitude: lng,
                            license_number: licenseNumber,
                            user_type: 'pharmacy'
                        };

                        let existing = { success: false, data: [] };
                        let conditions = { email: email };

                        if (email) {
                            existing = await oneKlicks.read('', 'pharmacies', conditions);
                        }

                        // If not found by email, try to find by Phone
                        if ((!existing.success || existing.data.length === 0) && phone) {
                            conditions = { phone: String(phone).trim() };
                            existing = await oneKlicks.read('', 'pharmacies', conditions);
                        }

                        // 3. Try exact match by Name
                        if (!existing.success || existing.data.length === 0) {
                            conditions = { name: displayName.trim() };
                            existing = await oneKlicks.read('', 'pharmacies', conditions);
                        }

                        // 4. Try Search by Name (Fuzzy fallback)
                        if (!existing.success || existing.data.length === 0) {
                            const searchObj = { name: displayName.trim() };
                            existing = await oneKlicks.read('', 'pharmacies', {}, 'id DESC', searchObj);
                        }

                        if (existing.success && existing.data.length > 0) {
                            const existingId = existing.data[0].id;
                            console.log(`Updating existing pharmacy ID: ${existingId}`);

                            // Fix for missing password
                            if (!existing.data[0].pass || existing.data[0].pass === 'NULL') {
                                commonData.pass = CryptoJS.SHA256("Ravindra12@").toString();
                            }

                            Object.keys(commonData).forEach(key => {
                                if (commonData[key] === null || commonData[key] === undefined || commonData[key] === '') {
                                    delete commonData[key];
                                }
                            });
                            const updateRes = await oneKlicks.update('', 'pharmacies', commonData, { id: existingId });
                            if (updateRes.success) {
                                successCount++;
                            } else {
                                console.error(`Failed to update ${displayName}:`, updateRes);
                                failCount++;
                            }
                        } else {
                            console.log(`Creating new pharmacy: ${displayName}`);
                            if (!email) {
                                const username = displayName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().substring(0, 15) + (Math.floor(Math.random() * 999));
                                email = `${username}@meddylist.import`;
                            }
                            const newData = {
                                ...commonData,

                                email: email,
                                pass: CryptoJS.SHA256("Ravindra12@").toString(),
                                status: '1',
                                user_type: 'pharmacy',
                                slug: displayName.toLowerCase().replace(/\s+/g, '-') + '-' + Math.floor(Math.random() * 1000),
                                owner_name: 'Owner', // Default
                                city: 'Hyderabad', // Default as per context usually, or extract from address
                                state: 'Telangana',
                                zip_code: '500001'
                            };
                            const createRes = await oneKlicks.create('', 'pharmacies', newData);
                            if (createRes.success) {
                                successCount++;
                            } else {
                                console.error(`Failed to create ${displayName}:`, createRes);
                                failCount++;
                            }
                        }
                    } catch (err) {
                        console.error("Error importing row", row, err);
                        failCount++;
                    }
                }
                message.success(`Import complete. Success: ${successCount}`);
                fetchPharmacies();
            } catch (error) {
                console.error(error);
                message.error("Failed to parse Excel");
            } finally {
                setImporting(false);
                e.target.value = null;
            }
        };
        reader.readAsBinaryString(file);
    };

    const handleExport = () => {
        const csvContent = [
            ['Name', 'Email', 'Phone', 'Address', 'City', 'State', 'Zip Code', 'License Number', 'Owner Name', 'Status'],
            ...pharmacies.map(pharmacy => [
                pharmacy.name,
                pharmacy.email,
                pharmacy.phone,
                pharmacy.address,
                pharmacy.city,
                pharmacy.state,
                pharmacy.zip_code,
                pharmacy.license_number,
                pharmacy.owner_name,
                pharmacy.status
            ])
        ].map(row => row.join(',')).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'pharmacies.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const totalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 0;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentPharmacies = Array.isArray(pharmacies) ? pharmacies : [];

    const handleSubmitTimings = async (e) => {
        e.preventDefault();
        const weekNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const timingsWithWeekName = timings.map((timing, idx) => {
            const getAmPm = (timeStr) => {
                if (!timeStr) return '';
                const [hour] = timeStr.split(':').map(Number);
                return hour >= 12 ? 'PM' : 'AM';
            };

            return {
                week: weekNames[idx],
                ...timing,
                opening_am_pm: getAmPm(timing.opening_time),
                closing_am_pm: getAmPm(timing.closing_time)
            };
        });

        const tableSchema = '';
        const tableName = 'pharmacies';
        const data = {
            opening_hours: JSON.stringify(timingsWithWeekName)
        };
        const conditions = { id: editingPharmacy.id };
        const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
        if (response.success) {
            message.success('Timings updated successfully');
            setTimingsShow(false);
            setEditingPharmacy(null);
            setTimings([]);
        } else {
            message.error('Error updating timings');
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleStatusToggle = async (record) => {
        try {
            const newStatus = record.status === 'active' ? 'inactive' : 'active';
            const tableSchema = '';
            const tableName = 'pharmacies';
            const payload = { status: newStatus };
            const condition = { id: record.id };

            const response = await oneKlicks.update(tableSchema, tableName, payload, condition);

            if (response && response.success) {
                message.success('Status updated successfully');
                await fetchPharmacies();
            } else {
                message.error('Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            message.error('Failed to update status');
        }
    };

    const handleLoginAs = async (pharmacy) => {
        try {
            message.loading("Logging in...", 1);
            const userData = {
                id: pharmacy.id,
                email: pharmacy.email,
                user_type: 'pharmacy',
                display_name: pharmacy.name,
                pass: pharmacy.pass
            };

            const success = await login(userData, '/pharmacy/dashboard', true);
            if (success) {
                message.success(`Logged in as ${pharmacy.name}`);
            } else {
                message.error("Login as failed");
            }
        } catch (error) {
            console.error("Login as error:", error);
            message.error("Login as failed");
        }
    };

    return (
        <>
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Pharmacy Management</h5>
                                <Badge bg="info">Pharmacies</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="flex-grow-1 me-2 h-40">
                                    <Form.Control
                                        placeholder="Search pharmacies..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="search-input"
                                    />
                                </InputGroup>

                                <Button className="btn-success h-40" onClick={() => setImportModalVisible(true)} icon={<CloudUploadOutlined />}>
                                    Import Map
                                </Button>
                                <Button
                                    className="h-40"
                                    onClick={handleImportClick}
                                    loading={importing}
                                    icon={<UploadOutlined />}
                                    style={{ backgroundColor: '#1890ff', color: 'white', borderColor: '#1890ff' }}
                                >
                                    Import Excel
                                </Button>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleExcelFileChange}
                                    accept=".xlsx, .xls"
                                />
                                <Button className="btn-warning h-40" onClick={handleExport} icon={<DownloadOutlined />}>
                                    Export
                                </Button>
                                <Button className="btn-primary h-40" onClick={handleAdd} icon={<PlusOutlined />}>
                                    Add New
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            {loading ? (
                                <div className="text-center p-5">Loading pharmacies...</div>
                            ) : (
                                <table className="table table-hover mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Banner / Photo</th>
                                            <th>Name / Details</th>
                                            <th>Address</th>
                                            <th>City</th>
                                            <th>License / Owner</th>
                                            <th>Timings</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPharmacies.map((pharmacy, index) => (
                                            <tr key={pharmacy.id}>
                                                <td>{startIndex + index + 1}</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        {(() => {
                                                            let banner = pharmacy.bannerurl || pharmacy.bannerid;
                                                            let photo = pharmacy.photourl || pharmacy.photoid;

                                                            // Fallback to photos array if banner/photo are empty
                                                            if (!banner || !photo) {
                                                                try {
                                                                    const parsedPhotos = JSON.parse(pharmacy.photos || '[]');
                                                                    if (Array.isArray(parsedPhotos) && parsedPhotos.length > 0) {
                                                                        if (!photo) photo = parsedPhotos[0];
                                                                        if (!banner) banner = parsedPhotos[1] || parsedPhotos[0];
                                                                    }
                                                                } catch (e) { }
                                                            }

                                                            return (
                                                                <>
                                                                    {banner ? (
                                                                        <ImageShow image={banner} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '4px' }} />
                                                                    ) : (
                                                                        <div style={{ width: 50, height: 50, backgroundColor: '#f0f0f0', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>No Banner</div>
                                                                    )}
                                                                    {photo ? (
                                                                        <ImageShow image={photo} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '50%' }} />
                                                                    ) : (
                                                                        <div style={{ width: 50, height: 50, backgroundColor: '#f0f0f0', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>No Photo</div>
                                                                    )}
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex flex-column">
                                                        <span className="fw-bold">{pharmacy.name}</span>
                                                        <small className="text-muted">{pharmacy.email}</small>
                                                        <small className="text-muted">{pharmacy.phone}</small>
                                                    </div>
                                                </td>
                                                <td>
                                                    {pharmacy.address ? (
                                                        <span>
                                                            {pharmacy.address.length > 30 ? (
                                                                <span
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setModalData({ display_name: pharmacy.name, address: pharmacy.address, showAddressModal: true });
                                                                    }}
                                                                    style={{ color: '#1890ff', textDecoration: 'underline', cursor: 'pointer' }}
                                                                >
                                                                    {pharmacy.address.substring(0, 30)}...
                                                                </span>
                                                            ) : (
                                                                pharmacy.address
                                                            )}
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted">No address</span>
                                                    )}
                                                </td>
                                                <td>{pharmacy.city}</td>
                                                <td>
                                                    <div className="d-flex flex-column">
                                                        <span>{pharmacy.license_number}</span>
                                                        <small className="text-muted">{pharmacy.owner_name}</small>
                                                    </div>
                                                </td>
                                                <td>
                                                    <Button
                                                        size="small"
                                                        onClick={() => {
                                                            setTimingsShow(true);
                                                            setEditingPharmacy(pharmacy);
                                                            if (pharmacy.opening_hours === "null" || !pharmacy.opening_hours) {
                                                                const defaultTimings = [
                                                                    { week: "Monday", open: "09:00", close: "21:00" },
                                                                    { week: "Tuesday", open: "09:00", close: "21:00" },
                                                                    { week: "Wednesday", open: "09:00", close: "21:00" },
                                                                    { week: "Thursday", open: "09:00", close: "21:00" },
                                                                    { week: "Friday", open: "09:00", close: "21:00" },
                                                                    { week: "Saturday", open: "09:00", close: "21:00" },
                                                                    { week: "Sunday", open: "10:00", close: "14:00" }
                                                                ];
                                                                setTimings(defaultTimings);
                                                            } else {
                                                                try {
                                                                    setTimings(JSON.parse(pharmacy.opening_hours));
                                                                } catch (e) {
                                                                    setTimings([]);
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        Edit Timings
                                                    </Button>
                                                </td>
                                                <td>
                                                    <Button
                                                        size="small"
                                                        onClick={() => handleStatusToggle(pharmacy)}
                                                        style={{
                                                            color: pharmacy.status === 'active' ? '#52c41a' : '#ff4d4f',
                                                            borderColor: pharmacy.status === 'active' ? '#b7eb8f' : '#ffa39e',
                                                            background: pharmacy.status === 'active' ? '#f6ffed' : '#fff1f0',
                                                        }}
                                                    >
                                                        {pharmacy.status === 'active' ? 'Active' : 'Inactive'}
                                                    </Button>
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-2 justify-content-end">
                                                        <Button
                                                            icon={<LoginOutlined />}
                                                            onClick={() => handleLoginAs(pharmacy)}
                                                            size="small"
                                                            title="Login as this Pharmacy"
                                                            style={{
                                                                backgroundColor: '#722ed1',
                                                                color: 'white',
                                                                borderColor: '#722ed1'
                                                            }}
                                                        />
                                                        <Button
                                                            icon={<EditOutlined />}
                                                            onClick={() => handleEdit(pharmacy)}
                                                            size="small"
                                                        />
                                                        <Button
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => handleDelete(pharmacy.id)}
                                                            size="small"
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <Paginationnew currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
                    </div>
                </div>

                {/* Address Modal */}
                <Modal
                    title="Full Address"
                    open={modalData.showAddressModal}
                    onCancel={() => setModalData({ ...modalData, showAddressModal: false })}
                    footer={[
                        <Button key="close" onClick={() => setModalData({ ...modalData, showAddressModal: false })}>
                            Close
                        </Button>
                    ]}
                >
                    <div>
                        <h4>{modalData.display_name}</h4>
                        <p><strong>Address:</strong></p>
                        <p style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            backgroundColor: '#f5f5f5',
                            padding: '15px',
                            borderRadius: '5px',
                            border: '1px solid #d9d9d9'
                        }}>
                            {modalData.address || 'No address available'}
                        </p>
                    </div>
                </Modal>

                {/* Timings Modal */}
                <Modal
                    title="Edit Timings"
                    open={timingsShow}
                    onCancel={() => {
                        setTimingsShow(false);
                        setEditingPharmacy(null);
                        setTimings([]);
                    }}
                    onOk={(e) => handleSubmitTimings(e)} // Trigger submit 
                    width={600}
                    footer={null} // We use the form submit
                >
                    <form onSubmit={handleSubmitTimings}>
                        <div className="timings-table-container" style={{ overflowX: 'auto' }}>
                            <table className="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th>Day</th>
                                        <th className="text-center">Open Time</th>
                                        <th className="text-center">Close Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day, idx) => (
                                        <tr key={day}>
                                            <td className="fw-bold">{day}</td>
                                            <td className="text-center">
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={timings[idx]?.open || ''}
                                                    onChange={e => {
                                                        const newTimings = [...timings];
                                                        if (!newTimings[idx]) newTimings[idx] = { week: day };
                                                        newTimings[idx].open = e.target.value;
                                                        setTimings(newTimings);
                                                    }}
                                                    required
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={timings[idx]?.close || ''}
                                                    onChange={e => {
                                                        const newTimings = [...timings];
                                                        if (!newTimings[idx]) newTimings[idx] = { week: day };
                                                        newTimings[idx].close = e.target.value;
                                                        setTimings(newTimings);
                                                    }}
                                                    required
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <Button onClick={() => {
                                setTimingsShow(false);
                                setEditingPharmacy(null);
                                setTimings([]);
                            }}>
                                Cancel
                            </Button>
                            <Button type="primary" htmlType="submit">
                                Save
                            </Button>
                        </div>
                    </form>
                </Modal>

                {/* Add/Edit Modal */}
                <Modal
                    title={editingPharmacy ? 'Edit Pharmacy' : 'Add Pharmacy'}
                    open={isModalVisible}
                    onCancel={() => setIsModalVisible(false)}
                    footer={null}
                    width={800}
                >
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Pharmacy Name</label>
                                <Input name="name" value={formData.name} onChange={handleInputChange} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Email</label>
                                <Input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Phone</label>
                                <Input name="phone" value={formData.phone} onChange={handleInputChange} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">License Number</label>
                                <Input name="license_number" value={formData.license_number} onChange={handleInputChange} required />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Address</label>
                            <Input name="address" value={formData.address} onChange={handleInputChange} required />
                        </div>

                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <label className="form-label">City</label>
                                <Input name="city" value={formData.city} onChange={handleInputChange} required />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">State</label>
                                <Input name="state" value={formData.state} onChange={handleInputChange} required />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Zip Code</label>
                                <Input name="zip_code" value={formData.zip_code} onChange={handleInputChange} required />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Latitude</label>
                                <Input name="lat" value={formData.lat} onChange={handleInputChange} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Longitude</label>
                                <Input name="long" value={formData.long} onChange={handleInputChange} required />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Banner Image</label>
                                <div className="mt-3">
                                    <div className="input-group">
                                        <Input
                                            placeholder="Or paste a banner URL here..."
                                            onPressEnter={async (e) => {
                                                const url = e.target.value.trim();
                                                if (url && url.startsWith('http')) {
                                                    try {
                                                        const res = await OneKlicksFileSDK.uploadFileFromUrl('pharmacies', 'public', url);
                                                        if (res && (res.fileid || res.fileId)) {
                                                            const fId = res.fileid || res.fileId;
                                                            setBannerId(fId);
                                                            setBannerUrl(fId);
                                                            message.success('Banner internalized from URL');
                                                            e.target.value = '';
                                                        } else {
                                                            message.error('Failed to internalize banner');
                                                        }
                                                    } catch (err) {
                                                        message.error('Error fetching banner from URL');
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {bannerUrl && <div className="mt-2"><ImageShow image={bannerUrl} width="100%" height={100} style={{ objectFit: 'cover', borderRadius: '4px' }} /></div>}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Photo</label>
                                <div className="mt-3">
                                    <div className="input-group">
                                        <Input
                                            placeholder="Or paste a photo URL here..."
                                            onPressEnter={async (e) => {
                                                const url = e.target.value.trim();
                                                if (url && url.startsWith('http')) {
                                                    try {
                                                        const res = await OneKlicksFileSDK.uploadFileFromUrl('pharmacies', 'public', url);
                                                        if (res && (res.fileid || res.fileId)) {
                                                            const fId = res.fileid || res.fileId;
                                                            setPhotoId(fId);
                                                            setPhotoUrl(fId);
                                                            message.success('Photo internalized from URL');
                                                            e.target.value = '';
                                                        } else {
                                                            message.error('Failed to internalize photo');
                                                        }
                                                    } catch (err) {
                                                        message.error('Error fetching photo from URL');
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {photoUrl && <div className="mt-2 text-center"><ImageShow image={photoUrl} width={100} height={100} style={{ borderRadius: '50%', objectFit: 'cover', border: '2px solid #ddd' }} /></div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Owner Name</label>
                                <Input name="owner_name" value={formData.owner_name} onChange={handleInputChange} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Status</label>
                                <select className="form-select" name="status" value={formData.status} onChange={handleInputChange} required>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button onClick={() => setIsModalVisible(false)}>Cancel</Button>
                            <Button type="primary" htmlType="submit" className="submit-button">
                                {editingPharmacy ? 'Update' : 'Add'}
                            </Button>
                        </div>
                    </form>
                </Modal>

                {/* Import Modal */}
                <Modal
                    title="Import Pharmacies from Google Maps"
                    open={importModalVisible}
                    onCancel={() => {
                        setImportModalVisible(false);
                        setCleanedData([]);
                        setShowDataPreview(false);
                        setSelectedCity('');
                        setCitySearchTerm('');
                    }}
                    width={800}
                    footer={null}
                >
                    <form onSubmit={handleImportSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Select City</label>
                            <div className="position-relative">
                                <Input
                                    placeholder="Type city name (e.g., Hyderabad)..."
                                    value={citySearchTerm}
                                    onChange={(e) => handleCitySearch(e.target.value)}
                                    required
                                />
                                {showCitySuggestions && citySuggestions.length > 0 && (
                                    <div className="position-absolute w-100 bg-white border rounded shadow-sm" style={{ zIndex: 1000, maxHeight: 200, overflowY: 'auto' }}>
                                        {citySuggestions.map((city, index) => (
                                            <div
                                                key={index}
                                                className="p-2 cursor-pointer hover-bg-light"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => selectCity(city)}
                                            >
                                                {city.description}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {selectedCity && <div className="mt-2 text-primary"><strong>Selected City:</strong> {selectedCity}</div>}
                        </div>

                        {isFetchingData && (
                            <div className="alert alert-info">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="spinner-border spinner-border-sm" role="status"></div>
                                    <span>Fetching data... {currentProcessingPharmacy && `Processing: ${currentProcessingPharmacy}`}</span>
                                </div>
                            </div>
                        )}

                        {showDataPreview && cleanedData.length > 0 && (
                            <>
                                <div className="mb-3 border p-3 rounded">
                                    <h6 className="mb-3">Import Settings</h6>
                                    <div className="d-flex flex-wrap gap-3">
                                        <label><input type="checkbox" checked={importConditions.includeImages} onChange={(e) => setImportConditions(prev => ({ ...prev, includeImages: e.target.checked }))} className="me-1" /> Images</label>
                                        <label><input type="checkbox" checked={importConditions.keepGoogleId} onChange={(e) => setImportConditions(prev => ({ ...prev, keepGoogleId: e.target.checked }))} className="me-1" /> Google ID</label>
                                        <label><input type="checkbox" checked={importConditions.includeReviews} onChange={(e) => setImportConditions(prev => ({ ...prev, includeReviews: e.target.checked }))} className="me-1" /> Reviews</label>
                                        <label><input type="checkbox" checked={importConditions.includeWebsite} onChange={(e) => setImportConditions(prev => ({ ...prev, includeWebsite: e.target.checked }))} className="me-1" /> Website</label>
                                        <label><input type="checkbox" checked={importConditions.includeHours} onChange={(e) => setImportConditions(prev => ({ ...prev, includeHours: e.target.checked }))} className="me-1" /> Hours</label>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <h6>Preview ({cleanedData.length} pharmacies)</h6>
                                    <div className="table-responsive" style={{ maxHeight: 300 }}>
                                        <table className="table table-sm table-bordered">
                                            <thead>
                                                <tr><th>Name</th><th>Phone</th><th>Status</th></tr>
                                            </thead>
                                            <tbody>
                                                {cleanedData.slice(0, 5).map((p, i) => (
                                                    <tr key={i}><td>{p.name}</td><td>{p.phone}</td><td>{p.status}</td></tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {cleanedData.length > 5 && <small className="text-muted">Showing first 5 records...</small>}
                                    </div>
                                </div>
                            </>
                        )}

                        {importProgress > 0 && (
                            <div className="mb-3">
                                <Progress percent={Math.round(importProgress)} status="active" />
                            </div>
                        )}

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button onClick={() => setImportModalVisible(false)}>Cancel</Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={!selectedCity || cleanedData.length === 0 || importProgress > 0}
                                loading={importProgress > 0 && importProgress < 100}
                            >
                                {importProgress > 0 ? 'Importing...' : 'Start Import'}
                            </Button>
                        </div>
                    </form>
                </Modal>
            </div>
        </>
    );
};

export default Pharmaces;
